import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en.json';
import arTranslation from './locales/ar.json';
import bnTranslation from './locales/bn.json';
import esTranslation from './locales/es.json';
import hiTranslation from './locales/hi.json';
import idTranslation from './locales/id.json';
import ptTranslation from './locales/pt.json';
import frTranslation from './locales/fr.json';
import itTranslation from './locales/it.json';
import deTranslation from './locales/de.json';
import viTranslation from './locales/vi.json';

const rawResources = {
  en: { translation: enTranslation },
  ar: { translation: arTranslation },
  bn: { translation: bnTranslation },
  es: { translation: esTranslation },
  hi: { translation: hiTranslation },
  id: { translation: idTranslation },
  pt: { translation: ptTranslation },
  fr: { translation: frTranslation },
  it: { translation: itTranslation },
  de: { translation: deTranslation },
  vi: { translation: viTranslation },
};

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

const isPlainObject = (value) => (
  value !== null &&
  typeof value === 'object' &&
  !Array.isArray(value)
);

const isCorruptTranslationValue = (value) => {
  if (typeof value !== 'string') return false;

  const text = value.trim();
  if (!text) return true;
  if (text.includes('\uFFFD') || /\?{2,}/.test(text)) return true;

  const questionCount = (text.match(/\?/g) || []).length;
  return questionCount >= 2 && questionCount / text.length > 0.08;
};

const cleanTranslationResource = (translation, fallback) => {
  const result = {};
  const keys = new Set([
    ...Object.keys(fallback || {}),
    ...Object.keys(translation || {}),
  ]);

  keys.forEach((key) => {
    const localValue = hasOwn(translation || {}, key) ? translation[key] : undefined;
    const fallbackValue = fallback?.[key];

    if (isPlainObject(fallbackValue)) {
      result[key] = cleanTranslationResource(
        isPlainObject(localValue) ? localValue : {},
        fallbackValue
      );
      return;
    }

    result[key] = localValue === undefined || localValue === null || isCorruptTranslationValue(localValue)
      ? fallbackValue
      : localValue;
  });

  return result;
};

const resources = Object.fromEntries(
  Object.entries(rawResources).map(([language, resource]) => [
    language,
    { translation: cleanTranslationResource(resource.translation, enTranslation) },
  ])
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    load: 'languageOnly', // Only load base language (e.g. 'en' instead of 'en-US')
    returnEmptyString: false,
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'cookie'],
      caches: ['localStorage'],
    },
  });

export default i18n;
